import { render, staticRenderFns } from "./branching-setup-modal.vue?vue&type=template&id=a44411de&"
import script from "./branching-setup-modal.vue?vue&type=script&lang=js&"
export * from "./branching-setup-modal.vue?vue&type=script&lang=js&"
import style0 from "./branching-setup-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "branching-setup-modal.vue"
export default component.exports